import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { Footnote } from 'src/app/models/footnote.model'
const SECTIONS = [
  'dashboard',
  'overview',
  'performance',
  'price',
  'portfolio',
  'distribution',
  'fund-management',
  'fund-literature',
]
@Injectable({
  providedIn: 'root',
})
export class FootnoteService {
  sections = SECTIONS
  private readonly _footnotes = new BehaviorSubject<Footnote[]>([])
  public footnotes$ = this._footnotes.asObservable()

  addFootnote(footnote: Footnote) {
    let footnotes = this._footnotes.getValue()
    footnote.id = footnotes.length + 1
    footnotes.push(footnote)
    footnotes = this.sortFootnotes(footnotes)
    for (let i = 0; i < footnotes.length; i++) {
      footnotes[i].id = i + 1
    }
    this._footnotes.next(footnotes)
  }

  /* istanbul ignore next */
  sortFootnotes(footnotes: Footnote[]): Footnote[] {
    return footnotes.sort((a, b) => {
      let sortingValue = 0
      if (this.sections.indexOf(a.section) < this.sections.indexOf(b.section)) {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        sortingValue = -1
      }
      if (this.sections.indexOf(a.section) > this.sections.indexOf(b.section)) {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        sortingValue = 1
      }
      return sortingValue
    })
  }
}
